import React from 'react';
import Svg, { Line, Path } from 'react-native-svg';

type MapIconProps = {
  color: string;
};

/**
 * Folded map outline, used by the map button on the news/guides screens.
 */
const MapIcon = ({ color }: MapIconProps) => {
  return (
    <Svg width={20} height={20} viewBox="0 0 24 24" fill="none">
      <Path
        d="M9 4.6 3.6 6.2a1 1 0 0 0-.6.9v11.2a1 1 0 0 0 1.3.95L9 17.4l6 1.9 4.7-1.6a1 1 0 0 0 .7-.95V5.6a1 1 0 0 0-1.3-.95L15 6.4 9 4.6Z"
        stroke={color}
        strokeWidth={1.8}
        strokeLinejoin="round"
      />
      <Line
        x1={9}
        y1={4.6}
        x2={9}
        y2={17.4}
        stroke={color}
        strokeWidth={1.8}
        strokeLinecap="round"
      />
      <Line
        x1={15}
        y1={6.4}
        x2={15}
        y2={19.3}
        stroke={color}
        strokeWidth={1.8}
        strokeLinecap="round"
      />
    </Svg>
  );
};

export default MapIcon;
